import React from 'react';
import logo from 'assets/img/icons/CL_logo_2.png';
import classNames from 'classnames';

interface LogoProps {
  width?: number;
  text?: boolean;
  textClass?: string;
  className?: string;
}

const Logo = ({ width = 58, text = true, textClass, className }: LogoProps) => {
  return (
    <div className={classNames(className, 'd-flex align-items-center me-1')}>
      <img src={logo} alt="phoenix" width={width} />
    </div>
  );
};

export default Logo;
